module.exports = __webpack_public_path__ + "img/plus.abb79324.svg";